import { render } from "./course3.vue?vue&type=template&id=3391832d&scoped=true"
import script from "./course3.vue?vue&type=script&lang=js"
export * from "./course3.vue?vue&type=script&lang=js"

import "./course3.vue?vue&type=style&index=0&id=3391832d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3391832d"]])

export default __exports__